@if (isServer || !menuDataFetched) {
    <app-menu-loader />
}

<ng-template #filterTemplate>
    <label class="veg-toggle-wrapper">
        <input type="checkbox" [(ngModel)]="is_veg" (click)="toggleOnlyVeg()" />
        <span class="veg-toggle">Veg</span>
    </label>
</ng-template>

@if (menuDataFetched) {
    <div>
        @if (isBrowser) {
            <section class="container menu-container">
                <div class="menu-sidebar-wrapper" *appFeatureToggle="'desktop'">
                    <h1>Menu</h1>
                    @if (menu) {
                        <ul class="menu-sidebar-items">
                            @for (category of menu?.sequence | categoryFilter: primaryBrandId; track category) {
                                <li (click)="selectCategory(category.id)">
                                    <a
                                        class="item"
                                        href="JavaScript:void(0);"
                                        [ngClass]="{ 'active-category': selectedCategory.id == category.id }"
                                        id="category-selector-{{ category.id }}">
                                        <img class="menu-category-img" [src]="category?.icon" alt="category icon" />
                                        <div class="category-info">
                                            <span>{{ category.label }}</span>
                                            <span class="category-count">
                                                {{ categoryCount[category.id] }}
                                            </span>
                                        </div>
                                    </a>
                                </li>
                            }
                        </ul>
                    }
                </div>
                <div class="menu-content-wrapper">
                    <div class="menu-items-wrapper">
                        <ng-container *appFeatureToggle="'desktop'">
                            <div class="menu-items-header" [style.padding-top]="showFreebieStrip ? '76px' : '26px'">
                                <div class="filter-section">
                                    <div routerLink="/search" class="search-bar">
                                        <span class="search-icon-wrapper">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                                <g fill="none" fill-rule="evenodd">
                                                    <g>
                                                        <path d="M0 0H24V24H0z" />
                                                        <g>
                                                            <path d="M0 0H24V24H0z" />
                                                            <g stroke="#0C0D0D">
                                                                <path
                                                                    d="M3.33 10.3c-.89-.964-1.499-2.154-1.76-3.44C.81 2.91 4.57-.45 8.4.13c1.918.305 3.58 1.494 4.49 3.21 1.095 2.112.794 4.678-.76 6.48-.855.982-2.006 1.66-3.28 1.93-.659.127-1.329.188-2 .18-.31 0-1.14-.15-1.36.16-.52.966-.967 1.969-1.34 3 0 0-1.5 3.26-1.86 3.67-.36.41-.76 1-1.18 1.1-.42.1-1.48-.15-.73-1.86.692-1.447 1.466-2.853 2.32-4.21L3.94 12"
                                                                    transform="translate(5 2)" />
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                        </span>
                                        <span>Search</span>
                                    </div>
                                    <ng-template [ngTemplateOutlet]="filterTemplate"></ng-template>
                                </div>
                            </div>
                        </ng-container>
                        <div class="menu-card-wrapper">
                            <div *appFeatureToggle="'mobile'" class="menu-nav-sticky" #mobileHeader>
                                <div class="menu-header-wrapper">
                                    @if (menu?.sequence?.length) {
                                        <div class="horizontal-scroller">
                                            <div class="category-scrollbar">
                                                <ul class="category-container" #categorySelectorById>
                                                    @for (
                                                        category of menu?.sequence | categoryFilter: primaryBrandId;
                                                        track category
                                                    ) {
                                                        <li class="category" (click)="selectCategory(category.id)">
                                                            <a
                                                                class="category-label"
                                                                href="JavaScript:void(0);"
                                                                [ngClass]="{
                                                                    'active-category': selectedCategory.id == category.id
                                                                }"
                                                                id="category-selector-{{ category.id }}">
                                                                {{ category.label }}
                                                            </a>
                                                        </li>
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            @if (menu?.sequence?.length === 0) {
                                <div class="no-item-to-show">
                                    <h2>No items to display with your current filter selection</h2>
                                </div>
                            }
                            @if (menu?.sequence?.length !== 0) {
                                <div [ngStyle]="{ 'margin-bottom': samplingStripText || cartItemQuantity ? '100px' : '0' }">
                                    @for (category of menu?.sequence | categoryFilter: primaryBrandId; track category) {
                                        <div id="category-{{ category.id }}" class="category-wrapper" #categoryWrap>
                                            <div class="clearfix"></div>
                                            <div class="category-description-container">
                                                <h3 class="category-heading">{{ category.label }}</h3>
                                                <div class="category-description">
                                                    {{ category.description }}
                                                </div>
                                            </div>
                                            <div class="category-product-wrapper">
                                                @for (
                                                    product of menu.data | menuProductFilter: category.id;
                                                    track product?.id;
                                                    let product_index = $index
                                                ) {
                                                    <div>
                                                        <div class="rectangle-layout-container">
                                                            <ui-card>
                                                                <div class="ui-card-image">
                                                                    <img
                                                                        src="{{ DEPLOY_URL }}/assets/images/missing.png"
                                                                        class="product-image"
                                                                        appDeferImageLoad
                                                                        alt="product image"
                                                                        [imageSrc]="product.image" />
                                                                </div>
                                                                <div class="ui-card-content">
                                                                    <div class="product-label">
                                                                        <div class="product-label-container">
                                                                            <div
                                                                                [ngClass]="{
                                                                                    veg: product.veg,
                                                                                    'non-veg': !product.veg
                                                                                }"></div>
                                                                            <h3 class="product-name">{{ product.label }}</h3>
                                                                        </div>
                                                                    </div>
                                                                    <app-truncate-text
                                                                        [customClasses]="'truncate-text-menu-description'"
                                                                        [clampLines]="2"
                                                                        [text]="product.description" />
                                                                </div>
                                                                <div class="ui-card-footer ui-card-actions">
                                                                    <div class="product-card-footer">
                                                                        <div class="prices-wrapper">
                                                                            @if (
                                                                                productPrices[product.id]?.price;
                                                                                as originalPrice
                                                                            ) {
                                                                                <div class="price">
                                                                                    &#8377;&nbsp;{{ originalPrice }}
                                                                                </div>
                                                                            }
                                                                            @if (
                                                                                productPrices[product.id]?.marked_price;
                                                                                as markedPrice
                                                                            ) {
                                                                                <div class="price product-marked-price">
                                                                                    &#8377;&nbsp;{{ markedPrice }}
                                                                                </div>
                                                                                @if (
                                                                                    passModel[product.id]?.has_pass &&
                                                                                    passModel[product.id]?.is_applied
                                                                                ) {
                                                                                    <img
                                                                                        src="{{
                                                                                            DEPLOY_URL
                                                                                        }}/assets/images/pass_logo.png"
                                                                                        alt="8Pass"
                                                                                        width="40" />
                                                                                }
                                                                            }
                                                                        </div>
                                                                        <div class="pull-right">
                                                                            <ui-counter-button
                                                                                [counter]="productQuantities[product.id] || 0"
                                                                                [disabled]="!isAddButtonActive(product.id)"
                                                                                [buttonLabel]="getButtonLabel(product.id)"
                                                                                (onCounterChange)="updateCart($event, product.id)"
                                                                                (handleDisabledState)="
                                                                                    handleDisabledState(product)
                                                                                ">
                                                                            </ui-counter-button>
                                                                        </div>
                                                                    </div>
                                                                    <app-pass-strip
                                                                        style="width: 100%"
                                                                        [product]="product"
                                                                        [passModel]="passModel"
                                                                        [productPrices]="productPrices"
                                                                        [deployUrl]="DEPLOY_URL">
                                                                    </app-pass-strip>
                                                                </div>
                                                            </ui-card>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </section>
        }
        <div
            class="browse-btn"
            [ngStyle]="{
                bottom:
                    showOutletStatusStrip && cartItemQuantity > 0
                        ? '160px'
                        : (samplingStripText && cartItemQuantity > 0) || showOutletStatusStrip
                          ? '130px'
                          : '90px',
                'z-index': menuOverlayOpen ? 9999 : 'initial'
            }"
            *appFeatureToggle="'mobile'">
            <button class="menu-btn center" #menuBtn (click)="openMenu()" [class.active]="menuOverlayOpen">
                <img
                    class="menu-icon"
                    appDeferImageLoad
                    [imageSrc]="menuOverlayOpen ? '/assets/images/ic_close_white.png' : '/assets/images/menu_icon.svg'"
                    alt="Menu Icon" />
                <span>{{ menuOverlayOpen ? 'Close' : 'Menu' }}</span>
            </button>
        </div>
        @if (showFreebieStrip && samplingStripText) {
            <div [ngStyle]="{ height: cartItemQuantity > 0 ? '100px' : '50px' }"></div>
            <div
                [ngClass]="isMobile ? 'freebie-container' : 'desktop-strip'"
                [ngStyle]="{ bottom: cartItemQuantity && isMobile > 0 ? '60px' : '0' }">
                <img src="{{ DEPLOY_URL }}/assets/images/confetti.svg" style="margin-right: 10px" />
                <span [innerHTML]="samplingStripText" style="line-height: 1.4; font-size: 12px"></span>
                @if (showFreebieTnC) {
                    <span class="tc-desc" (click)="openFreebieTC()">VIEW T&C</span>
                }
            </div>
        }
        @if (isMobile && cartItemQuantity > 0) {
            <div class="menu-checkout-wrapper" style="height: 60px">
                <div class="menu-checkout-items">
                    <div class="cart-info">
                        {{ cartItemQuantity }} {{ cartItemQuantity === 1 ? 'item' : 'items' }} | &#8377; {{ cartItemPrice }}
                    </div>
                    <div style="flex: 1">
                        <button
                            btn-primary
                            size="full"
                            data-test="proceed-to-cart"
                            (click)="proceedToCart()"
                            [disabled]="redirectionInProgress"
                            [isLoading]="redirectionInProgress">
                            CONTINUE
                            <img
                                alt="continue"
                                style="margin-left: 14px"
                                src="{{ DEPLOY_URL }}/assets/images/continue-arrow.png" />
                        </button>
                    </div>
                </div>
            </div>
        }
        @if (showOutletStatusStrip) {
            <div class="space-90"></div>
            <outlet-status-strip [style]="{ bottom: isMobile && cart_items?.length ? '60px' : '0' }"></outlet-status-strip>
        }
    </div>
}
